module.exports = __webpack_public_path__ + "img/daizy_city.9d8f5b1e.jpg";